export const SET_LAST_SIGN_UPS = 'SET_LAST_SIGN_UPS';
export const SET_DASHBOARD_CALENDAR_DATE = 'SET_DASHBOARD_CALENDAR_DATE';
export const SET_DASHBOARD_CALENDAR_ACTIVITY_TYPE = 'SET_DASHBOARD_CALENDAR_ACTIVITY_TYPE';
export const SET_DASHBOARD_RANGE_START_DATE = 'SET_DASHBOARD_RANGE_START_DATE';
export const SET_DASHBOARD_RANGE_END_DATE = 'SET_DASHBOARD_RANGE_END_DATE';
export const SET_DASHBOARD_RANGE = 'SET_DASHBOARD_RANGE';
export const RESET_DASHBOARD = 'RESET_DASHBOARD';
export const SET_DASHBOARD_ACTIVITIES = 'SET_DASHBOARD_ACTIVITIES';
export const TOGGLE_DASHBOARD_RANGE = 'TOGGLE_DASHBOARD_RANGE';
export const SET_ENROLLMENT = 'SET_ENROLLMENT';
export const SET_DASHBOARD_STATS = 'SET_DASHBOARD_STATS';


// WEBPACK FOOTER //
// ./src/store/modules/dashboard/mutations.js